'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _configuration = require('../../configuration');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: Add support and validations for multi target actions
function onSuccess() {
  var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (action) {
    return action.payload;
  };

  return function (state, action) {
    var _mergeState;

    return (0, _configuration.mergeState)(state, (_mergeState = {}, (0, _defineProperty3.default)(_mergeState, action.target + 'Loading', false), (0, _defineProperty3.default)(_mergeState, '' + action.target, selector(action, state)), (0, _defineProperty3.default)(_mergeState, action.target + 'Error', null), _mergeState));
  };
}

exports.default = onSuccess;